import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";
import { useFetch } from "../data/fetch/useFetch";
import { parseWidgetData } from "../data/parseWidgetData";
import { classIf, getConfiguration, oddToString } from "../data/utils";
import { useOddData } from "../common/OddWrapper";
import "./SwiperItems.css";

function Odd(props) {
  const odd = props.data;
  const [desc, selected, addBet] = useOddData(odd);

  return (
    <>
      {odd.value &&
        <div className={"swiper__items__content--dx" + classIf(selected, 'selected-odd')}>
          <div className="swiper__items__content--dx-title">

            {odd?.betData?.eqs?.map((e, i) => (
              e.ce == odd?.id &&
              <div className="odd_original" key={i}>{oddToString(e.qo)}</div>
            ))}
          </div>
          <div className="swiper__items__content--dx-content" onClick={addBet}>
            <div className="icon__ctaSvg">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">
                <path
                  fill="#00143c" stroke-width="0"
                  d="m0,6C0,2.58,2.51,0,6,0s6,2.58,6,6-2.51,6-6,6S0,9.42,0,6Zm5.12,3.1c0-1.21.35-2.5,1.25-3.43l1.35,1.82v-.29c0-1.75.1-3.5.28-5.21-1.73.11-4.01.54-5.5,1.54l1.59.5c-.59.82-.83,1.82-.83,2.82,0,1.61.73,3.39,2.11,3.75-.17-.39-.24-1.07-.24-1.5h0Z" />
              </svg>
            </div>
            <div className="highlight-odd">
              <span>{odd.value}</span>
            </div>
          </div>
        </div>
      }
    </>
  );
}

export const SwiperItems = () => {
  const conf = getConfiguration();

  const [isLoading, isError, data] = useFetch(conf.api.getWidgetCentrali, null, (data) =>
    parseWidgetData(data, false)
  );

  if (isLoading || isError || data?.highlights == null) {
    return null;
  }


  const highlights = data.highlights;

  function formatDate(dataToFormat) {
    const datePart = dataToFormat.split(' ')[0];
    const year = datePart.substring(0, 4);
    const month = datePart.substring(4, 6);
    const day = datePart.substring(6, 8);
    return `${day}/${month}/${year.substring(2)}`;
  }

  return (
    <>
      <div className="swiperItems__title title">Le nostre proposte</div>
      <Swiper
        slidesPerView={1}
        spaceBetween={10}
        breakpoints={{
          640: {
            slidesPerView: 1,
          },
          768: {
            slidesPerView: 1,
          },
          1300: {
            slidesPerView: 3,
          },
          1500: {
            slidesPerView: 4,
          },
        }}
        modules={[Pagination]}
        className="swiper__items swiper__maggiorate"
      >
        {highlights.map((e, index) => (
          <SwiperSlide key={index}>
            {" "}
            <div className="swiper__items--wrapper" >
              <div className="swiper__items--header">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                  <path d="M435.4 361.4l-89.7-6c-5.2-.3-10.3 1.1-14.5 4.2s-7.2 7.4-8.4 12.5l-22 87.2c-14.4 3.2-29.4 4.8-44.8 4.8s-30.3-1.7-44.8-4.8l-22-87.2c-1.3-5-4.3-9.4-8.4-12.5s-9.3-4.5-14.5-4.2l-89.7 6C61.7 335.9 51.9 307 49 276.2L125 228.3c4.4-2.8 7.6-7 9.2-11.9s1.4-10.2-.5-15L100.4 118c19.9-22.4 44.6-40.5 72.4-52.7l69.1 57.6c4 3.3 9 5.1 14.1 5.1s10.2-1.8 14.1-5.1l69.1-57.6c27.8 12.2 52.5 30.3 72.4 52.7l-33.4 83.4c-1.9 4.8-2.1 10.1-.5 15s4.9 9.1 9.2 11.9L463 276.2c-3 30.8-12.7 59.7-27.6 85.2zM256 48l.9 0-1.8 0 .9 0zM56.7 196.2c.9-3 1.9-6.1 2.9-9.1l-2.9 9.1zM132 423l3.8 2.7c-1.3-.9-2.5-1.8-3.8-2.7zm248.1-.1c-1.3 1-2.6 2-4 2.9l4-2.9zm75.2-226.7l-3-9.2c1.1 3 2.1 6.1 3 9.2zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm14.1-325.7c-8.4-6.1-19.8-6.1-28.2 0L194 221c-8.4 6.1-11.9 16.9-8.7 26.8l18.3 56.3c3.2 9.9 12.4 16.6 22.8 16.6l59.2 0c10.4 0 19.6-6.7 22.8-16.6l18.3-56.3c3.2-9.9-.3-20.7-8.7-26.8l-47.9-34.8z" />
                </svg>
                {e.title}
              </div>
              <div className="swiper__items__content--wrapper">
                <div className="swiper__items__content--sx">
                  <div className="swiper__items__content--pretitle">
                    {e.topDisclaimer} - {formatDate(e.timestampDB)}
                  </div>
                  <div className="swiper__items__content--title">
                    {" "}
                    {e.midDisclaimer}
                  </div>

                  <div className="swiper__items__content--subtitle">
                    {e.bottomDisclaimer}
                  </div>
                </div>
                {e.bets.map((bets, betsIndex) => (
                  <React.Fragment key={betsIndex}>
                    {bets.odds.map((odds, oddsIndex) => (
                      <Odd key={oddsIndex} data={odds} />
                    ))}
                  </React.Fragment>
                ))}
              </div>
            </div>{" "}
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  );
};



export default SwiperItems;
